import { useQueryClient } from "@tanstack/react-query";

import {
    ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY,
    getOrganizationFunctionQueryKey,
} from "src/modules/data-protection/constants/organizationFunctions";

import {
    assignFunctionsAfterUserCreate,
    syncUserFunctionAssignments,
} from "../assignments";

const useUserFunctionAssignments = (t) => {
    const queryClient = useQueryClient();

    const invalidate = () => {
        queryClient.invalidateQueries(ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY);
        queryClient.invalidateQueries(getOrganizationFunctionQueryKey("dpo"));
    };

    const assignAfterCreate = async ({ items, createResponse, token }) => {
        await assignFunctionsAfterUserCreate({
            items,
            createResponse,
            token,
            t,
        });
        invalidate();
    };

    const syncForUser = async ({ userId, selectedKeys, previousKeys }) => {
        await syncUserFunctionAssignments({
            userId,
            selectedKeys,
            previousKeys,
            t,
        });
        invalidate();
    };

    return {
        assignAfterCreate,
        syncForUser,
    };
};

export default useUserFunctionAssignments;
